import moment from 'moment-timezone';

const getDateFormatted = (date, diff) => {
  const newDate = moment(date).add(diff, 'days').clone();

  const day = `${newDate.date()}`;
  const month = `${newDate.month() * 1 + 1}`;
  const year = `${newDate.year()}`;

  return `${year}-${month.length === 1 ? '0' : ''}${month}-${
    day.length === 1 ? '0' : ''
  }${day}`;
};

export default getDateFormatted;
